import MatchablePlayerListItem from "@/app/activity/detail/components/dialog/playerTempMatchingDialog/MatchablePlayerListItem"
import { createActivityCommonStore } from "@/app/activity/store"
import Dialog from "@/components/dialog/Dialog"
import { useReadTeamDeviceListQuery } from "@/hooks/api/useTeamQuery"
import { ActivityData } from "@/types/activity"
import { PlayerDevice } from "@/types/device"
import { sortPlayers } from "@/utils/sort"

import { useMemo, useState } from "react"
import { useTranslation } from "react-i18next"

import "./playerTempMatchingDialog.scss"
import { createGlobalStore } from "@/stores/global"
import {
  useDeleteMatchPlayerMutation,
  useUpsertMatchPlayerMutation,
} from "@/hooks/api/useDataQuery"
import { useQueryClient } from "@tanstack/react-query"

export default function PlayerTempMatchingDialog({
  activityDataList,
}: {
  activityDataList: ActivityData[]
}) {
  const [selectedPlayer, setSelectedPlayer] = useState<number>(0)

  const queryClient = useQueryClient()
  const { t } = useTranslation()
  const { mutateAsync: matchPlayer } = useUpsertMatchPlayerMutation()
  const { mutateAsync: unMatchPlayer } = useDeleteMatchPlayerMutation()

  const { idfDataForMatch, setIdfDataForMatch } = createActivityCommonStore((state) => ({
    idfDataForMatch: state.activityDataForMatch,
    setIdfDataForMatch: state.setIdfDataForMatch,
  }))

  const { setSnackbar } = createGlobalStore((state) => ({
    setSnackbar: state.setSnackBar,
  }))

  const { data: deviceList } = useReadTeamDeviceListQuery()
  const idfPlayersInData = useMemo(() => {
    return [...new Set(activityDataList.map((activityData) => activityData.idfPlayer))].filter(
      (item) => item,
    )
  }, [activityDataList])

  const matchablePlayerList = useMemo(() => {
    const matchedPlayer = idfPlayersInData.filter((idfPlayer) =>
      activityDataList
        .filter((item) => item.idfPlayer === idfPlayer)
        .every((item) => item.matchedToActivity),
    )

    const none = {
      nickname: "none",

      deviceModel: "",
      deviceNumber: 0,
      deviceVersion: "",
    } as PlayerDevice
    const sorted = (deviceList || []).filter(
      (item: PlayerDevice) => !matchedPlayer.includes(item.idfPlayer),
    )

    sorted.sort(sortPlayers)

    return [none].concat(sorted)
  }, [idfPlayersInData, deviceList, activityDataList])

  const onClickSave = async () => {
    if (selectedPlayer > 0) {
      const payload = {
        idfData: idfDataForMatch?.idfData as number,
        payload: {
          idfPlayer: selectedPlayer,
        },
      }

      try {
        await matchPlayer(payload)

        setSnackbar({
          message: t("messages.successUpdate"),
          severity: "success",
          open: true,
        })

        queryClient.invalidateQueries({ queryKey: ["readTeamDeviceList"] })
        queryClient.invalidateQueries({ queryKey: ["readActivityData"] })
        setIdfDataForMatch(undefined)
      } catch (e) {
        console.error(e)
      }
    } else {
      if (idfDataForMatch?.matchedToActivity) {
        setSnackbar({
          message: t("messages.activityHasParticipating"),
          severity: "warning",
          open: true,
        })

        return
      }

      try {
        await unMatchPlayer(idfDataForMatch?.idfData as number)
        setSnackbar({
          message: t("messages.successUpdate"),
          severity: "success",
          open: true,
        })
        queryClient.invalidateQueries({ queryKey: ["readTeamDeviceList"] })
        queryClient.invalidateQueries({ queryKey: ["readActivityData"] })
        setIdfDataForMatch(undefined)
      } catch (e) {
        console.error(e)
      }
    }
  }

  // const fromDeviceSerial = useMemo(() => {
  //   if (!idfDataForMatch) {
  //     return ""
  //   }

  //   const { deviceModel, deviceNumber, deviceVersion } = idfDataForMatch

  //   return `${deviceModel}-${deviceVersion}-${deviceNumber}`
  // }, [idfDataForMatch])

  return (
    <Dialog
      open={!!idfDataForMatch}
      onClose={() => setIdfDataForMatch(undefined)}
      title={t("matchData")}
      maxWidth="600px"
      maxHeight="774px"
      onConfirm={onClickSave}>
      <div className="PlayerTempMatchingDialogCont">
        {/* <div className="from">
          <div>
            <p className="player">
              {idfDataForMatch?.devicePlayer?.uniformNumber}{" "}
              {idfDataForMatch?.devicePlayer?.nickname}
            </p>
          </div>
          <div>
            <p className="device-serial">{fromDeviceSerial}</p>
          </div>
        </div> */}
        <div className="to">
          {/* <label>{t("matchablePlayerList")}</label> */}
          <div className="matchable-player-list">
            {matchablePlayerList.map((player) => (
              <MatchablePlayerListItem
                {...player}
                key={player?.idfPlayer || 0}
                selected={(player?.idfPlayer || 0) === selectedPlayer}
                onClick={() => {
                  setSelectedPlayer(player?.idfPlayer || 0)
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </Dialog>
  )
}
